import { ChakraFlex, Icon, FAIconName } from '@equip.health/ui';

export interface DeleteRowIconProps {
  index: number;
  onClick: () => void;
}

const DeleteRowIcon = ({ index, onClick }: DeleteRowIconProps) => {
  const TOP_LEVEL_ID = `treatment-episode-row`;

  return (
    <ChakraFlex
      cursor="pointer"
      data-testid={`${TOP_LEVEL_ID}__delete`}
      id={`${TOP_LEVEL_ID}__delete__${index}`}
      onClick={() => onClick()}
      paddingBottom="20px"
    >
      <Icon color="critical.base" name={FAIconName.trashRegular} size="lg" />
    </ChakraFlex>
  );
};
export default DeleteRowIcon;
